const SESSION_KEY = "quartel.tradersOnline.v1";
const MAX_AGE_MS = 5 * 60 * 1000;

type CachedTradersOnlineSnapshot = {
  readonly count: number;
  readonly storedAt: number;
};

export function readCachedTradersOnline(): number | null {
  if (typeof window === "undefined") return null;
  const raw = window.sessionStorage.getItem(SESSION_KEY);
  if (!raw) return null;
  try {
    const parsed = JSON.parse(raw) as CachedTradersOnlineSnapshot;
    if (!Number.isFinite(parsed.count)) return null;
    if (Date.now() - parsed.storedAt > MAX_AGE_MS) return null;
    return parsed.count;
  } catch {
    return null;
  }
}

export function writeCachedTradersOnline(count: number): void {
  if (typeof window === "undefined") return;
  if (!Number.isFinite(count)) return;
  const snapshot: CachedTradersOnlineSnapshot = {
    count,
    storedAt: Date.now(),
  };
  try {
    window.sessionStorage.setItem(SESSION_KEY, JSON.stringify(snapshot));
  } catch {
    // Private mode/quota failures should degrade to network-only behavior.
  }
}
